export default __webpack_public_path__ + "static/Morph_moving_poster-4db43f87cdfea4a304ab2c92e998b97d.mp4";